import dayjs from "dayjs";
import i18nInst from "i18next";
import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import {
  appLanguageAtom,
  changeI18nLang,
  getLangLocalStorage,
  resolveAppLanguage,
  setLangLocalStorage,
} from "@ryde/shared";

import { landingInitDataAtomLanguageSelector } from "../selectors";

export const useLandingLangSwitch = () => {
  const initDataLanguage = useRecoilValue(landingInitDataAtomLanguageSelector);
  const setAppLanguage = useSetRecoilState(appLanguageAtom);

  useEffect(() => {
    const init = async (): Promise<void> => {
      const initialLang = resolveAppLanguage({
        storedLanguage: getLangLocalStorage(),
        preferenceLanguage: initDataLanguage,
        currentLanguage: i18nInst.language,
      });

      if (i18nInst.language !== initialLang) {
        await changeI18nLang(initialLang);
      }

      document.dir = i18nInst.dir();
      dayjs.locale(initialLang);
      setAppLanguage(initialLang);
      setLangLocalStorage(initialLang);
    };

    init();
  }, [initDataLanguage, setAppLanguage]);
};
